export default "__VITE_ASSET__Hyl2E3l7__"